import styles from "./AgeBadge.module.css";

/**
 * The palette slots a rule set may assign to an age category.
 *
 * A CLOSED set, matching `rules.AgeColorSlots` in Go — the server refuses
 * anything else, so a slot arriving here is always one of these. The map
 * below is where a drift would show: a slot the server accepts but this
 * file does not know renders untinted, which is precisely the silent
 * failure the server-side validation exists to prevent.
 *
 * Separated from the components so the module exports only components —
 * `react-refresh/only-export-components`, and the rule is right: a file
 * that mixes the two loses fast refresh for the component.
 */
export const AGE_COLOR_SLOTS = [
  "age-1",
  "age-2",
  "age-3",
  "age-4",
  "age-5",
  "age-6",
  "age-7",
  "age-8",
] as const;

export type AgeColorSlot = (typeof AGE_COLOR_SLOTS)[number];

const SLOT_CLASS: Record<AgeColorSlot, string> = {
  "age-1": styles.age1,
  "age-2": styles.age2,
  "age-3": styles.age3,
  "age-4": styles.age4,
  "age-5": styles.age5,
  "age-6": styles.age6,
  "age-7": styles.age7,
  "age-8": styles.age8,
};

export function isAgeColorSlot(value: string): value is AgeColorSlot {
  return (AGE_COLOR_SLOTS as readonly string[]).includes(value);
}

/**
 * The class pair for a slot, or undefined when there is no colour.
 *
 * Undefined rather than an empty string on purpose: passed to `Badge`'s
 * `className` it leaves the variant untouched, so „no colour" renders as
 * the plain muted badge instead of a tinted one with nothing in it.
 */
export function ageSlotClass(color: string | undefined): string | undefined {
  if (!color || !isAgeColorSlot(color)) return undefined;
  return `${styles.slot} ${SLOT_CLASS[color]}`;
}

/** The swatch class for the rule-set picker. */
export function ageSwatchClass(color: AgeColorSlot): string {
  return `${styles.slot} ${SLOT_CLASS[color]} ${styles.swatch}`;
}
